// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3C0f-","tab":"ProcedureTabs_tab__3d7zo"};